import { Icon } from '@/components/ui/Icon';

/**
 * בורר "גלולה" לבנה בסגנון v2 ("מחלקה  כל המחלקות ▾") — תווית שקטה וערך
 * מודגש, עם select טבעי שקוף מעליו (מקלדת/קורא מסך עובדים כרגיל).
 */
export function PillSelect<T extends string>({
  label, value, options, onChange, ariaLabel,
}: {
  label: string;
  value: T;
  options: { value: T; label: string }[];
  onChange: (v: T) => void;
  ariaLabel?: string;
}) {
  const current = options.find((o) => o.value === value)?.label ?? '';
  return (
    <label
      className="card"
      style={{
        position: 'relative', display: 'inline-flex', alignItems: 'center', gap: 8, height: 38,
        padding: '0 12px', borderRadius: 10, fontSize: 'var(--t-sm)', cursor: 'pointer', whiteSpace: 'nowrap',
      }}
    >
      <span style={{ color: 'var(--muted)' }}>{label}</span>
      <span style={{ fontWeight: 600 }}>{current}</span>
      <Icon name="chevronD" size={14} />
      <select
        value={value}
        aria-label={ariaLabel ?? label}
        onChange={(e) => onChange(e.target.value as T)}
        style={{ position: 'absolute', inset: 0, width: '100%', height: '100%', opacity: 0, cursor: 'pointer' }}
      >
        {options.map((o) => <option key={o.value} value={o.value}>{o.label}</option>)}
      </select>
    </label>
  );
}
